(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────────────────────────
  // Both vars are overridable via window.* set BEFORE this script loads.
  // The Liquid snippet sets TCP_AI_AVATAR_URL to the Shopify CDN URL.
  // The standalone test page sets TCP_API_URL to '/api/chat' (relative).
  var API_URL       = window.TCP_API_URL || 'https://trust-pharmacy-chatbot-production.up.railway.app/api/chat';
  var WA_API_URL    = API_URL.replace('/chat', '/whatsapp/next');
  var CLICK_URL     = API_URL.replace('/chat', '/click');
  var ORDER_URL     = API_URL.replace('/chat', '/order');
  var WA_FALLBACK   = '96590992025';
  var STORE         = 'https://2bcosmetic1.myshopify.com';
  var STORAGE_KEY   = 'tpc_session';
  var AI_AVATAR_URL = window.TCP_AI_AVATAR_URL || '';

  // ── DOM ─────────────────────────────────────────────────────────────────────
  var panel      = document.getElementById('tcpPanel');
  var backdrop   = document.getElementById('tcpBackdrop');
  var messagesEl = document.getElementById('tcpMessages');
  var inputEl    = document.getElementById('tcpInput');
  var sendBtn    = document.getElementById('tcpSendBtn');
  var chatForm   = document.getElementById('tcpForm');
  var closeBtn   = document.getElementById('tcpClose');
  var bubbleBtn  = document.getElementById('tcpBubble');
  var handoffEl  = document.getElementById('tcpHandoff');

  if (!panel || !messagesEl || !chatForm) return;

  // ── Session ID (anonymous, per browser session) ──────────────────────────────
  function genUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  var sessionId = (function() {
    try {
      var stored = sessionStorage.getItem('tpc_sid');
      if (stored) return stored;
      var id = genUUID();
      sessionStorage.setItem('tpc_sid', id);
      return id;
    } catch(_) { return genUUID(); }
  })();

  // ── State ───────────────────────────────────────────────────────────────────
  var history          = [];  // message array sent to the API
  var renders          = [];  // visual rendering data for sessionStorage restoration
  var handoffActive    = false;
  var handoffWaNumber  = '';
  var activeQREl     = null;
  var panelOpen      = false;
  var pendingOrder   = null; // { formEl, productListEl, confirmBtn, nameInput, phoneInput, addrInput, locationInput, products[] }
  var customerInfo   = { name: '', phone: '', area: '', address: '', location: '' };
  var chatEverOpened      = false; // true after first open from ANY entry point
  var bubbleDragged       = false; // set by drag logic to suppress the next click
  var lastOrderCtaProduct = null;  // last product shown — used by "Ready to order?" CTA
  var activeCtaEl         = null;  // the current CTA button element

  // Shared label state — read by drag IIFE to hide/reshow label during drag
  var _labelShown     = false; // true while the product-page callout is visible
  var _labelDismissed = false; // true after user clicks the X to permanently dismiss

  function _positionLabel(lbl) {
    if (!lbl) return;
    var rect = bubbleBtn.getBoundingClientRect();
    var lw   = 190;
    var left = rect.right + 12;
    var flipped = false;
    if (left + lw > window.innerWidth - 10) { left = rect.left - lw - 12; flipped = true; }
    left = Math.max(10, left);
    lbl.style.top  = Math.round(rect.top + rect.height / 2) + 'px';
    lbl.style.left = Math.round(left) + 'px';
    lbl.classList.toggle('arrow-right', flipped);
  }

  // ── Utilities ───────────────────────────────────────────────────────────────
  function hhMM() {
    return new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  }

  function shortenTitle(title) {
    var cleaned = title
      .replace(/\s*[-–(]+\s*\d+\s*(ml|l|g|mg|kg|oz|tablets?|capsules?|pcs?|count|pieces?|pack|sachets?)\b.*/i, '')
      .trim();
    var base = cleaned || title;
    return base.length > 38 ? base.slice(0, 36).trimEnd() + '…' : base;
  }

  function scrollBottom() { messagesEl.scrollTop = messagesEl.scrollHeight; }

  function setDisabled(d) {
    inputEl.disabled = d;
    sendBtn.disabled = d;
  }

  // ── Rendering ───────────────────────────────────────────────────────────────
  function mkBotBubble(text, showTime) {
    var w = document.createElement('div');
    w.className = 'tcp-msg tcp-msg--bot';

    if (AI_AVATAR_URL) {
      var avatar = document.createElement('img');
      avatar.className = 'tcp-msg-avatar';
      avatar.src = AI_AVATAR_URL;
      avatar.alt = '';
      avatar.setAttribute('aria-hidden', 'true');
      w.appendChild(avatar);
    }

    var content = document.createElement('div');
    content.className = 'tcp-msg__content';

    var b = document.createElement('div');
    b.className = 'tcp-msg__bubble';
    b.textContent = text;
    b.dir = 'auto';
    content.appendChild(b);

    if (showTime) {
      var m = document.createElement('div');
      m.className = 'tcp-msg__meta';
      m.textContent = hhMM();
      content.appendChild(m);
    }

    w.appendChild(content);
    messagesEl.appendChild(w);
    scrollBottom();
  }

  function mkUserBubble(text) {
    var w = document.createElement('div');
    w.className = 'tcp-msg tcp-msg--user';
    var b = document.createElement('div');
    b.className = 'tcp-msg__bubble';
    b.textContent = text;
    b.dir = 'auto';
    w.appendChild(b);
    var m = document.createElement('div');
    m.className = 'tcp-msg__meta';
    m.textContent = hhMM();
    w.appendChild(m);
    messagesEl.appendChild(w);
    scrollBottom();
  }

  function trackClick(productId, productTitle, buttonType) {
    try {
      fetch(CLICK_URL, {
        method   : 'POST',
        headers  : { 'Content-Type': 'application/json' },
        body     : JSON.stringify({
          session_id   : sessionId,
          product_id   : String(productId),
          product_title: productTitle || '',
          button_type  : buttonType,
        }),
        keepalive: true,
      }).catch(function () {}); // swallow — tracking must never block navigation
    } catch (e) {}
  }

  function mkProductCard(p) {
    var card = document.createElement('div');
    card.className = 'tcp-product-card';

    if (p.image) {
      var img = document.createElement('img');
      img.className = 'tcp-pcard-img';
      img.src = p.image;
      img.alt = p.title;
      img.loading = 'lazy';
      img.onerror = function () {
        var ph = document.createElement('div');
        ph.className = 'tcp-pcard-img-empty';
        ph.textContent = '💊';
        card.insertBefore(ph, card.firstChild);
        img.remove();
      };
      card.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'tcp-pcard-img-empty';
      ph.textContent = '💊';
      card.appendChild(ph);
    }

    var info = document.createElement('div');
    info.className = 'tcp-pcard-info';

    var titleEl = document.createElement('p');
    titleEl.className = 'tcp-pcard-title';
    titleEl.textContent = shortenTitle(p.title);
    titleEl.title = p.title;

    var priceEl = document.createElement('p');
    priceEl.className = 'tcp-pcard-price';
    var n = parseFloat(p.price);
    priceEl.textContent = isNaN(n) ? '' : (n.toFixed(3) + ' ' + (p.currency || 'KWD'));

    var actions = document.createElement('div');
    actions.className = 'tcp-pcard-actions';

    var detailsBtn = document.createElement('a');
    detailsBtn.className = 'tcp-pcard-btn tcp-pcard-btn--ghost';
    detailsBtn.href = STORE + '/products/' + p.handle;
    detailsBtn.target = '_blank';
    detailsBtn.rel = 'noopener';
    detailsBtn.textContent = 'التفاصيل / Details';
    detailsBtn.addEventListener('click', function () { trackClick(p.id, p.title, 'details'); });

    var addBtn = document.createElement('button');
    addBtn.className = 'tcp-pcard-btn tcp-pcard-btn--outline';
    addBtn.type = 'button';
    addBtn.textContent = 'أضف للسلة / Add';
    addBtn.addEventListener('click', function () {
      if (!p.variantId) { showCartNotice('⚠️ Variant unavailable'); return; }
      trackClick(p.id, p.title, 'add_to_cart');
      window.open(STORE + '/cart/add?id=' + p.variantId + '&quantity=1', '_blank', 'noopener');
      showCartNotice('🛒 Opening cart…');
    });

    var buyBtn = document.createElement('a');
    buyBtn.className = 'tcp-pcard-btn tcp-pcard-btn--primary';
    buyBtn.href = p.variantId
      ? STORE + '/cart/' + p.variantId + ':1'
      : STORE + '/products/' + p.handle;
    buyBtn.target = '_blank';
    buyBtn.rel = 'noopener';
    buyBtn.textContent = 'اشتري الآن / Buy';
    buyBtn.addEventListener('click', function () { trackClick(p.id, p.title, 'buy_now'); });

    actions.appendChild(detailsBtn);
    actions.appendChild(addBtn);
    actions.appendChild(buyBtn);
    info.appendChild(titleEl);
    info.appendChild(priceEl);
    info.appendChild(actions);
    card.appendChild(info);
    messagesEl.appendChild(card);
    lastOrderCtaProduct = p; // track for the "Ready to order?" CTA
    scrollBottom();
  }

  function showCartNotice(text) {
    var n = document.createElement('div');
    n.className = 'tcp-cart-notice';
    n.textContent = text;
    messagesEl.appendChild(n);
    scrollBottom();
    setTimeout(function () { n.remove(); }, 3000);
  }

  function mkWhatsAppHandoffBtn(number, prefilledText) {
    var a = document.createElement('a');
    a.className = 'tcp-wa-handoff';
    a.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(prefilledText || '');
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">' +
        '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>' +
      '</svg>' +
      '<span>تواصل مع فريقنا عبر واتساب · WhatsApp our team</span>';
    messagesEl.appendChild(a);
    scrollBottom();
  }

  function renderSegments(segments) {
    var lastText = segments.reduce(function (acc, s, i) {
      return s.type === 'text' ? i : acc;
    }, -1);
    segments.forEach(function (s, i) {
      if (s.type === 'text' && s.content.trim()) {
        mkBotBubble(s.content.trim(), i === lastText);
      } else if (s.type === 'product' && s.product) {
        mkProductCard(s.product);
      } else if (s.type === 'whatsapp' && s.number) {
        mkWhatsAppHandoffBtn(s.number, s.prefilledText);
      }
    });
  }

  // ── Typing indicator ─────────────────────────────────────────────────────────
  function showTyping() {
    var el = document.createElement('div');
    el.id = 'tcpTyping';
    el.className = 'tcp-typing';
    el.innerHTML = '<div class="tcp-typing-dot"></div><div class="tcp-typing-dot"></div><div class="tcp-typing-dot"></div>';
    messagesEl.appendChild(el);
    scrollBottom();
  }
  function hideTyping() {
    var el = document.getElementById('tcpTyping');
    if (el) el.remove();
  }

  // ── Handoff ──────────────────────────────────────────────────────────────────
  function showHandoff(waNumber) {
    handoffActive   = true;
    handoffWaNumber = waNumber || handoffWaNumber || WA_FALLBACK;

    // Build the pre-filled WhatsApp message. Include the last user message
    // (second-to-last history entry after the assistant's handoff reply) as context.
    var lastUserMsg = '';
    for (var i = history.length - 1; i >= 0; i--) {
      if (history[i].role === 'user') { lastUserMsg = history[i].content || ''; break; }
    }
    var preText = 'مرحباً، كنت أتحدث مع مساعد Trust Pharmacy الذكي وانتهت الجلسة. أحتاج مساعدة.';
    if (lastUserMsg) {
      var snippet = lastUserMsg.length > 120 ? lastUserMsg.slice(0, 118) + '…' : lastUserMsg;
      preText += '\nآخر سؤالي: ' + snippet;
    }

    var btn = handoffEl.querySelector('.tcp-handoff-btn');
    if (btn) {
      btn.href = 'https://wa.me/' + handoffWaNumber + '?text=' + encodeURIComponent(preText);
    }

    handoffEl.hidden = false;
    setDisabled(true);
  }

  // ── Quick-reply chips ────────────────────────────────────────────────────────
  function clearQR() {
    if (activeQREl) { activeQREl.remove(); activeQREl = null; }
  }

  function renderQR(quickReplies) {
    clearQR();
    if (!quickReplies || quickReplies.length === 0) return;
    var row = document.createElement('div');
    row.className = 'tcp-qr-row';
    quickReplies.forEach(function (qr) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tcp-qr-chip';
      chip.textContent = qr.label;
      chip.addEventListener('click', function () { handleQR(qr, row); });
      row.appendChild(chip);
    });
    messagesEl.appendChild(row);
    activeQREl = row;
    scrollBottom();
  }

  // Render chips from the [[CHIPS:...]] backend system.
  // Uses the same .tcp-qr-chip CSS class as the legacy quick-reply chips.
  function renderChips(chips) {
    clearQR();
    if (!chips || chips.length === 0) return;
    var row = document.createElement('div');
    row.className = 'tcp-qr-row';
    chips.forEach(function (chip) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tcp-qr-chip';
      btn.textContent = chip.label;
      btn.addEventListener('click', function () { handleChip(chip, row); });
      row.appendChild(btn);
    });
    messagesEl.appendChild(row);
    activeQREl = row;
    scrollBottom();
  }

  function showChipsOrQR(data) {
    if (data.chips && data.chips.length) {
      renderChips(data.chips);
    } else {
      renderQR(data.quickReplies);
    }
    showOrderCta();
  }

  function showOrderCta() {
    if (activeCtaEl) { activeCtaEl.remove(); activeCtaEl = null; }
    if (!lastOrderCtaProduct) return;
    var p = lastOrderCtaProduct;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tcp-order-cta';
    btn.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none" width="15" height="15" aria-hidden="true" style="flex-shrink:0">' +
        '<path d="M3 3h14l-1.5 9H4.5L3 3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
        '<circle cx="7" cy="17" r="1.2" fill="currentColor"/>' +
        '<circle cx="13" cy="17" r="1.2" fill="currentColor"/>' +
      '</svg>' +
      '<span>طلب سريع ⚡ اطلب الآن</span>';
    btn.addEventListener('click', function () { openOrderForm(p); });
    messagesEl.appendChild(btn);
    activeCtaEl = btn;
    scrollBottom();
  }

  async function handleChip(chip, rowEl) {
    rowEl.querySelectorAll('.tcp-qr-chip').forEach(function (c) { c.disabled = true; });
    activeQREl = null;
    mkUserBubble(chip.label);
    history.push({ role: 'user', content: chip.label });
    renders.push({ role: 'user', text: chip.label });
    saveSession();
    setDisabled(true);
    showTyping();
    try {
      var body = { messages: history, session_id: sessionId };
      if (chip.action === 'alternatives') {
        body.quickReplyAction = { action: chip.action, productId: chip.productId, productTitle: chip.productTitle };
      }
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      hideTyping();
      var data = res.ok ? await res.json() : null;
      if (!data) {
        mkBotBubble('عذراً، صار خطأ. حاول مرة ثانية.', true);
        return;
      }
      var reply = data.reply || '';
      var segs = (Array.isArray(data.segments) && data.segments.length > 0)
        ? data.segments : [{ type: 'text', content: reply || 'عذراً، لم يصلني رد.' }];
      renderSegments(segs);
      showChipsOrQR(data);
      if (reply) {
        history.push({ role: 'assistant', content: reply });
        renders.push({ role: 'bot', text: reply, segments: segs });
        saveSession();
      }
      if (data.handoff) showHandoff(data.whatsappNumber);
    } catch (e) {
      hideTyping();
      mkBotBubble('تعذّر الاتصال بالخادم. / Could not reach the server.', true);
    } finally {
      if (!handoffActive) { setDisabled(false); inputEl.focus(); }
    }
  }

  async function handleQR(qr, rowEl) {
    rowEl.querySelectorAll('.tcp-qr-chip').forEach(function (c) { c.disabled = true; });
    activeQREl = null;
    mkUserBubble(qr.label);
    history.push({ role: 'user', content: qr.label });
    renders.push({ role: 'user', text: qr.label });
    saveSession();
    setDisabled(true);
    showTyping();
    try {
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: history,
          session_id: sessionId,
          quickReplyAction: { action: qr.action, productId: qr.productId, productTitle: qr.productTitle },
        }),
      });
      hideTyping();
      var data = res.ok ? await res.json() : null;
      if (!data) {
        var em = 'عذراً، صار خطأ. حاول مرة ثانية.';
        mkBotBubble(em, true);
        return;
      }
      var reply = data.reply || '';
      var segs = (Array.isArray(data.segments) && data.segments.length > 0)
        ? data.segments : [{ type: 'text', content: reply || 'عذراً، لم يصلني رد.' }];
      renderSegments(segs);
      showChipsOrQR(data);
      if (reply) {
        history.push({ role: 'assistant', content: reply });
        renders.push({ role: 'bot', text: reply, segments: segs });
        saveSession();
      }
      if (data.handoff) showHandoff(data.whatsappNumber);
    } catch (e) {
      hideTyping();
      mkBotBubble('تعذّر الاتصال بالخادم. / Could not reach the server.', true);
    } finally {
      if (!handoffActive) { setDisabled(false); inputEl.focus(); }
    }
  }

  // ── One-Click Order form ──────────────────────────────────────────────────
  function openOrderForm(product) {
    if (!panelOpen) openPanel(true);
    if (pendingOrder) {
      var isDuplicate = pendingOrder.products.some(function (p) { return p.handle === product.handle; });
      // Always move the form card to the current bottom of the conversation
      messagesEl.appendChild(pendingOrder.formEl);
      if (isDuplicate) {
        showCartNotice('⚠️ "' + shortenTitle(product.title) + '" موجود بالفعل / already in your order');
      } else {
        addProductRow(product);
        showCartNotice('✅ "' + shortenTitle(product.title) + '" أُضيف للطلب / added to order');
      }
      scrollBottom();
      return;
    }
    buildOrderCard();
    // Pre-fetch a rotating WhatsApp number so confirmOrder can use it
    // synchronously (no popup-blocker risk on the window.open call).
    fetch(WA_API_URL, { method: 'POST' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (pendingOrder && d && d.number) pendingOrder.waNumber = d.number; })
      .catch(function () {});
    messagesEl.appendChild(pendingOrder.formEl);
    addProductRow(product);
    scrollBottom();
  }

  function buildOrderCard() {
    var card = document.createElement('div');
    card.className = 'tcp-order-card';

    var cardTitle = document.createElement('p');
    cardTitle.className = 'tcp-order-card-title';
    cardTitle.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none" width="14" height="14" style="flex-shrink:0" aria-hidden="true">' +
      '<path d="M3 3h14l-1.5 9H4.5L3 3z" stroke="#005f56" stroke-width="1.7" stroke-linejoin="round"/>' +
      '<circle cx="7" cy="17" r="1.2" fill="#005f56"/><circle cx="13" cy="17" r="1.2" fill="#005f56"/></svg>' +
      ' اطلب عبر واتساب / WhatsApp Order';
    card.appendChild(cardTitle);

    var productsLabel = document.createElement('p');
    productsLabel.className = 'tcp-order-section-label';
    productsLabel.textContent = 'المنتجات / Products';
    card.appendChild(productsLabel);

    var productListEl = document.createElement('div');
    productListEl.className = 'tcp-order-products';
    card.appendChild(productListEl);

    var infoLabel = document.createElement('p');
    infoLabel.className = 'tcp-order-section-label';
    infoLabel.textContent = 'معلومات التوصيل / Delivery Info';
    card.appendChild(infoLabel);

    var fieldsEl = document.createElement('div');
    fieldsEl.className = 'tcp-order-fields';

    var nameF     = mkOrderField('الاسم / Name',                         'text', customerInfo.name);
    var phoneF    = mkOrderField('الهاتف / Phone',                        'tel',  customerInfo.phone);
    // ── Kuwait +965 prefix + 8-digit validation ──────────────────────────────
    (function () {
      var phoneInp = phoneF.input;
      phoneInp.parentNode.removeChild(phoneInp);
      // Strip any stored +965 prefix and non-digits from prior session
      phoneInp.value = (phoneInp.value || '').replace(/^\+?965/, '').replace(/\D/g, '').slice(0, 8);
      phoneInp.maxLength = 8;
      phoneInp.placeholder = '5XXXXXXX';
      phoneInp.setAttribute('inputmode', 'numeric');
      phoneInp.addEventListener('beforeinput', function (e) {
        if (e.data !== null && !/^\d+$/.test(e.data)) e.preventDefault();
      });
      phoneInp.addEventListener('input', function () {
        phoneInp.value = phoneInp.value.replace(/\D/g, '').slice(0, 8);
      });
      var phoneRow = document.createElement('div');
      phoneRow.className = 'tcp-phone-row';
      phoneRow.dir = 'ltr';
      var prefix = document.createElement('span');
      prefix.className = 'tcp-phone-prefix';
      prefix.textContent = '+965';
      var note = document.createElement('p');
      note.className = 'tcp-phone-note';
      note.textContent = '📱 استخدم رقمك المسجل في واتساب / Use your WhatsApp-registered number';
      phoneRow.appendChild(prefix);
      phoneRow.appendChild(phoneInp);
      phoneF.wrapper.appendChild(phoneRow);
      phoneF.wrapper.appendChild(note);
    }());

    // ── Kuwait area dropdown (Arabic display / English DB value) ─────────────
    var areaWrapper = document.createElement('div');
    areaWrapper.className = 'tcp-order-field';
    var areaLabel = document.createElement('label');
    areaLabel.textContent = 'المنطقة / Area';
    var areaSelect = document.createElement('select');
    areaSelect.className = 'tcp-area-select';
    var areaPlaceholder = document.createElement('option');
    areaPlaceholder.value = '';
    areaPlaceholder.textContent = 'اختر المنطقة / Select Area';
    areaPlaceholder.disabled = true;
    areaSelect.appendChild(areaPlaceholder);
    [
      { gov: 'محافظة العاصمة', areas: [
        ['الكويت','Kuwait City'],['الشرق','Sharq'],['الميناء','Minaah'],['الدسمة','Dasma'],
        ['الروضة','Rawda'],['الأندلس','Andalus'],['النزهة','Nuzha'],['الفيحاء','Faiha'],
        ['كيفان','Kaifan'],['الشامية','Shamiya'],['الدوحة','Doha'],['غرناطة','Granada'],
        ['اليرموك','Yarmouk'],['المنصورية','Mansouria'],['الخالدية','Khaldiya'],
        ['القادسية','Qadsiya'],['الدعية','Daiya'],['العديلية','Adailiya'],
        ['الصليبيخات','Sulaibikhat'],['الشويخ','Shuwaikh'],['بنيد القار','Bnaid Al-Gar'],
        ['الصالحية','Salehiya'],['المرقاب','Mirqab'],['ضاحية عبدالله السالم','Abdullah Al-Salem'],
        ['الري','Rai'],['قرطبة','Qortuba'],['سكية','Sukkiya'],
      ]},
      { gov: 'محافظة حولي', areas: [
        ['حولي','Hawalli'],['الرميثية','Rumaithiya'],['السالمية','Salmiya'],
        ['بيان','Bayan'],['البدع','Bidaa'],['الجابرية','Jabriya'],
        ['الزهراء','Zahraa'],['ميدان حولي','Maidan Hawalli'],['الشعب','Shaab'],
        ['سلوى','Salwa'],['العقيلة','Uqaila'],['ضاحية مبارك العبدالله','Mubarak Al-Abdullah'],
      ]},
      { gov: 'محافظة الفروانية', areas: [
        ['الفروانية','Farwaniya'],['خيطان','Khaitan'],['الرقعي','Ruqai'],
        ['الرابية','Rabiya'],['الرحاب','Rehab'],['جليب الشيوخ','Jleeb Al-Shuyoukh'],
        ['الشدادية','Shadadiya'],['إشبيلية','Ishbiliya'],['القيروان','Qairawan'],
        ['الفردوس','Firdous'],['صباح الناصر','Sabah Al-Nasser'],
        ['عمر بن الخطاب','Omar Bin Khattab'],['الضجيج','Dhajij'],['العارضية','Ardiya'],
      ]},
      { gov: 'محافظة مبارك الكبير', areas: [
        ['مبارك الكبير','Mubarak Al-Kabeer'],['أبو الحصانية','Abu Al-Hasaniya'],
        ['المسيلة','Mussayel'],['القصور','Qusour'],['صباح السالم','Sabah Al-Salem'],
        ['الفنيطيس','Funaitees'],['ضاحية صباح السالم','Sabah Al-Salem Suburb'],
        ['المنقف','Mangaf'],['صبحان','Sabhan'],
      ]},
      { gov: 'محافظة الأحمدي', areas: [
        ['الأحمدي','Ahmadi'],['الفحيحيل','Fahaheel'],['هدية','Hadiya'],
        ['أبو حليفة','Abu Halifa'],['المهبولة','Mahboula'],['الرقة','Ruqqa'],
        ['ضاحية فهد الأحمد','Fahad Al-Ahmad'],['الصباحية','Sabahiya'],
        ['الوفرة','Wafra'],['الخيران','Khairan'],['ميناء عبدالله','Mina Abdullah'],
        ['بنيدر','Bnaidar'],['علي صباح السالم','Ali Sabah Al-Salem'],
        ['الزور','Zour'],['الجليعة','Julaiaa'],['نويصيب','Nuwaiseeb'],
      ]},
      { gov: 'محافظة الجهراء', areas: [
        ['الجهراء','Jahra'],['تيماء','Tayma'],['العيون','Uyoun'],
        ['القصر','Qasr'],['النسيم','Naseem'],['الواحة','Waaha'],
        ['الأمغرة','Amghara'],['الصليبية','Sulaibiya'],['وادي الشعيب','Wadi Al-Shuaib'],
        ['كبد','Kabd'],['العبدلي','Abdali'],['الصبية','Subiya'],
        ['النهضة','Nahda'],['القرين','Qurain'],
      ]},
    ].forEach(function (g) {
      var grp = document.createElement('optgroup');
      grp.label = g.gov;
      g.areas.forEach(function (a) {
        var opt = document.createElement('option');
        opt.value = a[1];
        opt.textContent = a[0];
        grp.appendChild(opt);
      });
      areaSelect.appendChild(grp);
    });
    var outsideOpt = document.createElement('option');
    outsideOpt.value = 'outside_kuwait';
    outsideOpt.textContent = 'خارج الكويت';
    areaSelect.appendChild(outsideOpt);
    areaSelect.value = customerInfo.area || '';
    areaWrapper.appendChild(areaLabel);
    areaWrapper.appendChild(areaSelect);

    var addrF     = mkOrderField('العنوان / Address',                     'text', customerInfo.address);
    var locationF = mkOrderField('الموقع (اختياري) / Location (optional)', 'text', customerInfo.location);
    // ── GPS button for location field ────────────────────────────────────────
    (function () {
      var locInp = locationF.input;
      locInp.parentNode.removeChild(locInp);
      var locRow = document.createElement('div');
      locRow.className = 'tcp-loc-row';
      var locBtn = document.createElement('button');
      locBtn.type = 'button';
      locBtn.className = 'tcp-loc-btn';
      locBtn.setAttribute('aria-label', 'Get current location / الموقع الحالي');
      locBtn.innerHTML =
        '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-linecap="round">' +
          '<line x1="10" y1="1.5"  x2="10" y2="4.5"  stroke-width="1.8"/>' +
          '<line x1="10" y1="15.5" x2="10" y2="18.5" stroke-width="1.8"/>' +
          '<line x1="1.5"  y1="10" x2="4.5"  y2="10" stroke-width="1.8"/>' +
          '<line x1="15.5" y1="10" x2="18.5" y2="10" stroke-width="1.8"/>' +
          '<circle cx="10" cy="10" r="4" stroke-width="1.5"/>' +
          '<circle cx="10" cy="10" r="1.5" fill="currentColor" stroke="none"/>' +
        '</svg>';
      locBtn.addEventListener('click', function () {
        if (!navigator.geolocation) return;
        locBtn.disabled = true;
        locBtn.classList.add('tcp-loc-btn--loading');
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            locInp.value = 'https://maps.google.com/?q=' + pos.coords.latitude + ',' + pos.coords.longitude;
            locInp.dispatchEvent(new Event('input'));
            locBtn.disabled = false;
            locBtn.classList.remove('tcp-loc-btn--loading');
          },
          function () {
            locBtn.disabled = false;
            locBtn.classList.remove('tcp-loc-btn--loading');
          },
          { timeout: 10000 }
        );
      });
      locRow.appendChild(locInp);
      locRow.appendChild(locBtn);
      locationF.wrapper.appendChild(locRow);
    }());

    fieldsEl.appendChild(nameF.wrapper);
    fieldsEl.appendChild(phoneF.wrapper);
    fieldsEl.appendChild(areaWrapper);
    fieldsEl.appendChild(addrF.wrapper);
    fieldsEl.appendChild(locationF.wrapper);
    card.appendChild(fieldsEl);

    var confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = 'tcp-order-confirm';
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'تأكيد الطلب عبر واتساب / Confirm via WhatsApp ✓';
    card.appendChild(confirmBtn);

    pendingOrder = {
      formEl:        card,
      productListEl: productListEl,
      confirmBtn:    confirmBtn,
      nameInput:     nameF.input,
      phoneInput:    phoneF.input,
      areaSelect:    areaSelect,
      addrInput:     addrF.input,
      locationInput: locationF.input,
      products:      [],
    };

    [nameF.input, phoneF.input, addrF.input, locationF.input].forEach(function (inp) {
      inp.addEventListener('input', validateOrderForm);
    });
    areaSelect.addEventListener('change', validateOrderForm);
    confirmBtn.addEventListener('click', confirmOrder);
  }

  function mkOrderField(labelText, inputType, prefill) {
    var wrapper = document.createElement('div');
    wrapper.className = 'tcp-order-field';

    var lbl = document.createElement('label');
    lbl.textContent = labelText;
    wrapper.appendChild(lbl);

    var inp = document.createElement('input');
    inp.type  = inputType;
    inp.value = prefill || '';
    if (inputType === 'tel') {
      inp.addEventListener('input', function () {
        inp.value = inp.value.replace(/[^0-9+\-\s()]/g, '');
      });
    }
    wrapper.appendChild(inp);
    return { wrapper: wrapper, input: inp };
  }

  function addProductRow(product) {
    if (!pendingOrder) return;

    var row = document.createElement('div');
    row.className = 'tcp-order-product-row';

    var nameEl = document.createElement('span');
    nameEl.className = 'tcp-order-product-name';
    nameEl.textContent = shortenTitle(product.title);
    nameEl.title = product.title;

    var qtyLabel = document.createElement('span');
    qtyLabel.className = 'tcp-order-qty-label';
    qtyLabel.textContent = 'الكمية:';

    var qtyInput = document.createElement('input');
    qtyInput.type      = 'number';
    qtyInput.min       = '1';
    qtyInput.max       = '999';
    qtyInput.value     = '1';
    qtyInput.className = 'tcp-order-qty-input';

    // Block non-digit keystrokes at the source
    qtyInput.addEventListener('beforeinput', function (e) {
      if (e.data !== null && !/^\d+$/.test(e.data)) e.preventDefault();
    });
    // Sanitize paste or other insertion paths
    qtyInput.addEventListener('input', function () {
      qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
      if (qtyInput.value === '' || parseInt(qtyInput.value, 10) < 1) qtyInput.value = '1';
      validateOrderForm();
    });

    row.appendChild(nameEl);
    row.appendChild(qtyLabel);
    row.appendChild(qtyInput);
    pendingOrder.productListEl.appendChild(row);
    pendingOrder.products.push({ id: product.id || '', title: product.title, handle: product.handle, price: product.price, currency: product.currency || 'KWD', qtyInput: qtyInput });
    validateOrderForm();
  }

  function validateOrderForm() {
    if (!pendingOrder) return;
    var ok =
      pendingOrder.nameInput.value.trim().length > 0 &&
      pendingOrder.phoneInput.value.replace(/\D/g, '').length === 8 &&
      pendingOrder.areaSelect.value !== '' &&
      pendingOrder.addrInput.value.trim().length > 0 &&
      pendingOrder.products.length > 0 &&
      pendingOrder.products.every(function (p) {
        var v = parseInt(p.qtyInput.value, 10);
        return !isNaN(v) && v >= 1;
      });
    pendingOrder.confirmBtn.disabled = !ok;
    customerInfo.name     = pendingOrder.nameInput.value.trim();
    customerInfo.phone    = pendingOrder.phoneInput.value.trim();
    customerInfo.area     = pendingOrder.areaSelect.value;
    customerInfo.address  = pendingOrder.addrInput.value.trim();
    customerInfo.location = pendingOrder.locationInput.value.trim();
    saveSession();
  }

  function confirmOrder() {
    if (!pendingOrder || pendingOrder.confirmBtn.disabled) return;
    var WA_NUMBER = pendingOrder.waNumber || WA_FALLBACK;
    var name      = pendingOrder.nameInput.value.trim();
    var phone     = '+965' + pendingOrder.phoneInput.value.replace(/\D/g, '');
    var areaEn    = pendingOrder.areaSelect.value;
    var areaAr    = pendingOrder.areaSelect.options[pendingOrder.areaSelect.selectedIndex].text;
    var address   = pendingOrder.addrInput.value.trim();
    var location  = pendingOrder.locationInput.value.trim();
    var products  = pendingOrder.products;

    var lines = [
      'السلام عليكم 👋',
      'ودي أطلب من صيدلية Trust:',
      '',
    ];
    var waTotal = 0;
    products.forEach(function (p) {
      var qty       = parseInt(p.qtyInput.value, 10) || 1;
      var unitPrice = parseFloat(p.price) || 0;
      var lineTotal = unitPrice * qty;
      waTotal += lineTotal;
      var qtyStr = qty > 1 ? ' × ' + qty : '';
      lines.push('▪ ' + p.title + qtyStr);
      if (unitPrice > 0) {
        lines.push('  السعر: ' + (qty > 1
          ? unitPrice.toFixed(3) + ' × ' + qty + ' = ' + lineTotal.toFixed(3)
          : unitPrice.toFixed(3)) + ' KWD');
      }
      lines.push('  ' + STORE + '/products/' + p.handle);
    });
    if (waTotal > 0) {
      lines.push('');
      lines.push('💰 المجموع الكلي: ' + waTotal.toFixed(3) + ' KWD');
    }
    lines.push('');
    lines.push('📦 بيانات التوصيل:');
    lines.push('الاسم: ' + name);
    lines.push('الهاتف: ' + phone);
    lines.push('المنطقة: ' + areaAr);
    lines.push('العنوان: ' + address);
    if (location) lines.push('الموقع: ' + location);
    lines.push('');
    lines.push('✅ أؤكد هذا الطلب');

    var waUrl = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(lines.join('\n'));

    try {
      fetch(ORDER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          session_id     : sessionId,
          customer_name  : name,
          customer_phone : phone,
          area           : areaEn,
          address        : address,
          location       : location || null,
          whatsapp_number: WA_NUMBER,
          products: products.map(function (p) {
            return {
              productId    : p.id || '',
              productTitle : p.title,
              productHandle: p.handle,
              quantity     : parseInt(p.qtyInput.value, 10) || 1,
              productPrice : parseFloat(p.price) || 0,
              currency     : p.currency || 'KWD',
            };
          }),
        }),
      });
    } catch (_) {}

    window.open(waUrl, '_blank', 'noopener,noreferrer');

    var orderedNames = products.map(function (p) { return shortenTitle(p.title); }).join(' و ');
    pendingOrder.formEl.remove();
    pendingOrder = null;

    mkBotBubble(
      '✅ تم تجهيز طلبك! سيفتح واتساب الآن.\nYour order is ready — WhatsApp is opening.',
      true
    );
    setTimeout(function () {
      sendMessage('أكملت طلبي لـ: ' + orderedNames + '. هل تقترح منتجات تكمل هذا الطلب؟', null, true);
    }, 700);
  }

  // ── Session storage ──────────────────────────────────────────────────────────
  function saveSession() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        history:        history,
        renders:        renders,
        handoff:        handoffActive,
        handoffWaNum:   handoffWaNumber,
        customerInfo:   customerInfo,
      }));
    } catch (e) {}
  }

  function loadSession() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var d = JSON.parse(raw);
      // Always restore customer info regardless of whether there is chat history
      if (d.customerInfo && typeof d.customerInfo === 'object') {
        customerInfo.name     = d.customerInfo.name     || '';
        customerInfo.phone    = d.customerInfo.phone    || '';
        customerInfo.area     = d.customerInfo.area     || '';
        customerInfo.address  = d.customerInfo.address  || '';
        customerInfo.location = d.customerInfo.location || '';
      }
      if (!Array.isArray(d.history) || d.history.length === 0) return false;
      history         = d.history;
      renders         = Array.isArray(d.renders) ? d.renders : [];
      handoffActive   = !!d.handoff;
      handoffWaNumber = (typeof d.handoffWaNum === 'string') ? d.handoffWaNum : '';
      return true;
    } catch (e) {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
      return false;
    }
  }

  function restoreConversation() {
    renders.forEach(function (item) {
      if (item.role === 'user') {
        mkUserBubble(item.text);
      } else if (item.role === 'bot') {
        if (item.segments && item.segments.length > 0) {
          renderSegments(item.segments);
        } else if (item.text) {
          mkBotBubble(item.text, true);
        }
      }
    });
    if (handoffActive) showHandoff(handoffWaNumber);
    scrollBottom();
  }

  // ── Panel open / close ───────────────────────────────────────────────────────
  function openPanel(skipWelcome) {
    if (panelOpen) return;
    chatEverOpened = true;
    panelOpen = true;
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    bubbleBtn.classList.remove('is-visible');
    if (!skipWelcome && history.length === 0) showWelcome();
    setTimeout(function () { inputEl.focus(); }, 340);
  }

  function closePanel() {
    if (!panelOpen) return;
    panelOpen = false;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (chatEverOpened) bubbleBtn.classList.add('is-visible');
  }

  // ── Welcome ──────────────────────────────────────────────────────────────────
  function showWelcome() {
    mkBotBubble(
      'أهلاً وسهلاً! 👋 أنا نور، مساعدتك في Trust Pharmacy.\n\n' +
      'أقدر أساعدك تلاقي المنتج المناسب - سواء كان مسكن ألم، فيتامينات، منتجات عناية بالبشرة أو الشعر، أو غيرها.\n\n' +
      'شو تحتاج اليوم؟',
      true
    );
  }

  // ── Send message ─────────────────────────────────────────────────────────────
  async function sendMessage(text, quickReplyAction, resultedInOrder) {
    clearQR();
    mkUserBubble(text);
    history.push({ role: 'user', content: text });
    renders.push({ role: 'user', text: text });
    saveSession();
    setDisabled(true);
    showTyping();
    try {
      var body = { messages: history, session_id: sessionId };
      if (quickReplyAction) body.quickReplyAction = quickReplyAction;
      if (resultedInOrder) body.resulted_in_order = true;
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      hideTyping();
      var data = res.ok ? await res.json() : null;
      if (!data) {
        var em = 'عذراً، صار خطأ. حاول مرة ثانية. / Sorry, something went wrong.';
        mkBotBubble(em, true);
        history.push({ role: 'assistant', content: em });
        renders.push({ role: 'bot', text: em, segments: [{ type: 'text', content: em }] });
        saveSession();
        return;
      }
      var reply = data.reply || '';
      var segs = (Array.isArray(data.segments) && data.segments.length > 0)
        ? data.segments : [{ type: 'text', content: reply || 'عذراً، لم يصلني رد.' }];
      renderSegments(segs);
      showChipsOrQR(data);
      if (reply) {
        history.push({ role: 'assistant', content: reply });
        renders.push({ role: 'bot', text: reply, segments: segs });
        saveSession();
      }
      if (data.handoff) showHandoff(data.whatsappNumber);
    } catch (e) {
      hideTyping();
      var em2 = 'تعذّر الاتصال بالخادم. / Could not reach the server.';
      mkBotBubble(em2, true);
    } finally {
      if (!handoffActive) { setDisabled(false); inputEl.focus(); }
    }
  }

  // ── Product context init (from "Ask AI about this product" button) ───────────
  async function initWithProduct(productTitle) {
    if (history.length > 0) {
      // Existing session — open the panel so the user sees their history,
      // then append a visible product-enquiry message as a natural continuation.
      openPanel(true);
      await sendMessage('لدي سؤال عن هذا المنتج: ' + productTitle);
      return;
    }

    // No prior history — start fresh with a silent trigger so the AI's
    // first visible message is already product-aware (no blank chat).
    messagesEl.innerHTML = '';
    activeQREl = null;
    handoffActive = false;
    handoffEl.hidden = true;
    setDisabled(false);
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}

    openPanel(true);
    mkBotBubble(
      'جاري تحميل معلومات عن "' + productTitle + '"…\nLooking up "' + productTitle + '" for you…',
      false
    );
    showTyping();
    setDisabled(true);

    var trigger = 'أنا مهتم بهذا المنتج وأريد أسأل عنه: ' + productTitle;
    history.push({ role: 'user', content: trigger });
    // trigger is silent — not pushed to renders

    try {
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history, session_id: sessionId }),
      });
      hideTyping();
      messagesEl.innerHTML = '';

      var data = res.ok ? await res.json() : null;
      if (!data) {
        mkBotBubble('عذراً، لم أتمكن من تحميل معلومات المنتج.', true);
        return;
      }
      var reply = data.reply || '';
      var segs = (Array.isArray(data.segments) && data.segments.length > 0)
        ? data.segments : [{ type: 'text', content: reply || 'عذراً، حصل خطأ.' }];
      renderSegments(segs);
      showChipsOrQR(data);
      if (reply) {
        history.push({ role: 'assistant', content: reply });
        renders.push({ role: 'bot', text: reply, segments: segs });
        saveSession();
      }
      if (data.handoff) showHandoff(data.whatsappNumber);
    } catch (e) {
      hideTyping();
      messagesEl.innerHTML = '';
      mkBotBubble('تعذّر الاتصال بالخادم. / Could not reach the server.', true);
    } finally {
      if (!handoffActive) { setDisabled(false); inputEl.focus(); }
    }
  }

  // ── Collection context init (from "Ask AI about this collection" button) ─────
  async function initWithCollection(collectionTitle) {
    if (history.length > 0) {
      openPanel(true);
      await sendMessage('أبا أسأل عن مجموعة ' + collectionTitle);
      return;
    }

    messagesEl.innerHTML = '';
    activeQREl = null;
    handoffActive = false;
    handoffEl.hidden = true;
    setDisabled(false);
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}

    openPanel(true);
    mkBotBubble(
      'جاري البحث في مجموعة "' + collectionTitle + '"…\nLooking up the ' + collectionTitle + ' collection for you…',
      false
    );
    showTyping();
    setDisabled(true);

    var trigger = 'أبا أسأل عن مجموعة ' + collectionTitle;
    history.push({ role: 'user', content: trigger });
    // trigger is silent — not pushed to renders

    try {
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history, session_id: sessionId }),
      });
      hideTyping();
      messagesEl.innerHTML = '';

      var data = res.ok ? await res.json() : null;
      if (!data) {
        mkBotBubble('عذراً، لم أتمكن من تحميل معلومات المجموعة.', true);
        return;
      }
      var reply = data.reply || '';
      var segs = (Array.isArray(data.segments) && data.segments.length > 0)
        ? data.segments : [{ type: 'text', content: reply || 'عذراً، حصل خطأ.' }];
      renderSegments(segs);
      showChipsOrQR(data);
      if (reply) {
        history.push({ role: 'assistant', content: reply });
        renders.push({ role: 'bot', text: reply, segments: segs });
        saveSession();
      }
      if (data.handoff) showHandoff(data.whatsappNumber);
    } catch (e) {
      hideTyping();
      messagesEl.innerHTML = '';
      mkBotBubble('تعذّر الاتصال بالخادم. / Could not reach the server.', true);
    } finally {
      if (!handoffActive) { setDisabled(false); inputEl.focus(); }
    }
  }

  // ── Event listeners ──────────────────────────────────────────────────────────
  chatForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = inputEl.value.trim();
    if (!text) return;
    inputEl.value = '';
    inputEl.style.height = 'auto';
    sendMessage(text);
  });

  inputEl.addEventListener('input', function () {
    inputEl.style.height = 'auto';
    inputEl.style.height = Math.min(inputEl.scrollHeight, 100) + 'px';
  });

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      chatForm.requestSubmit ? chatForm.requestSubmit() : chatForm.dispatchEvent(new Event('submit'));
    }
  });

  closeBtn.addEventListener('click', closePanel);
  backdrop.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (panelOpen && e.key === 'Escape') closePanel();
  });

  bubbleBtn.addEventListener('click', function () {
    if (bubbleDragged) { bubbleDragged = false; return; }
    var pageProduct = window.TCP_PAGE_PRODUCT || null;
    if (pageProduct && !chatEverOpened) {
      // Product page, first open — start a product-aware conversation
      var lbl = document.getElementById('tcpBubbleLabel');
      if (lbl) { lbl.classList.remove('is-visible'); setTimeout(function(){ lbl.hidden = true; }, 260); }
      initWithProduct(pageProduct);
    } else {
      openPanel();
    }
  });

  // Catch clicks on product-page "Ask AI" buttons (rendered by ask-ai-button.liquid)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ask-ai-product-trigger');
    if (!btn) return;
    e.preventDefault();
    var title = btn.getAttribute('data-product-title');
    if (title) initWithProduct(title);
  });

  // ── Public API (called by contact-launcher.js and ask-ai-button.liquid) ──────
  window.TrustPharmacyChatWidget = {
    open: openPanel,
    close: closePanel,
    openWithProduct   : function (title) { initWithProduct(title); },
    openWithCollection: function (title) { initWithCollection(title); },
  };

  // ── Draggable bubble — Messenger/Telegram style ──────────────────────────────
  (function () {
    var dragging  = false;
    var moved     = false;
    var startCX, startCY, startLeft, startTop;
    var MARGIN = 14;

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(v, hi)); }

    function setXY(left, top) {
      bubbleBtn.style.left   = left + 'px';
      bubbleBtn.style.top    = top  + 'px';
      bubbleBtn.style.right  = 'auto';
      bubbleBtn.style.bottom = 'auto';
    }

    function snap() {
      var w    = bubbleBtn.offsetWidth  || 58;
      var h    = bubbleBtn.offsetHeight || 58;
      var rect = bubbleBtn.getBoundingClientRect();
      var midX = rect.left + w / 2;
      var top  = clamp(rect.top, MARGIN, window.innerHeight - h - MARGIN);
      var left = midX < window.innerWidth / 2
        ? MARGIN
        : window.innerWidth - w - MARGIN;
      bubbleBtn.classList.add('tcp-bubble--snapping');
      setXY(left, top);
      try { localStorage.setItem('tpc_bubble_pos', JSON.stringify({ v: 2, left: left, top: top })); } catch (_) {}
      setTimeout(function () { bubbleBtn.classList.remove('tcp-bubble--snapping'); }, 300);
    }

    function onStart(e) {
      if (e.button && e.button !== 0) return;
      var t = e.touches ? e.touches[0] : e;
      dragging  = true;
      moved     = false;
      startCX   = t.clientX;
      startCY   = t.clientY;
      var rect  = bubbleBtn.getBoundingClientRect();
      startLeft = rect.left;
      startTop  = rect.top;
      // Don't preventDefault on touch — that would suppress the synthetic click event
      // on mobile (tapping the bubble would become a no-op). Only prevent on mouse to
      // block text-selection during desktop drag.
      if (!e.touches) e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      var t  = e.touches ? e.touches[0] : e;
      var dx = t.clientX - startCX;
      var dy = t.clientY - startCY;
      // Touch fingers wobble 5-10 px naturally; use a larger threshold so a normal
      // tap on mobile doesn't get classified as a drag and suppress the click event.
      var THRESH = e.touches ? 15 : 5;
      if (!moved && Math.abs(dx) < THRESH && Math.abs(dy) < THRESH) return;
      if (!moved) {
        moved = true;
        // Drag confirmed — hide the label callout so it doesn't float away from bubble
        if (_labelShown) {
          var lbl = document.getElementById('tcpBubbleLabel');
          if (lbl) lbl.classList.remove('is-visible');
        }
      }
      var w = bubbleBtn.offsetWidth  || 58;
      var h = bubbleBtn.offsetHeight || 58;
      setXY(
        clamp(startLeft + dx, MARGIN, window.innerWidth  - w - MARGIN),
        clamp(startTop  + dy, MARGIN, window.innerHeight - h - MARGIN)
      );
      e.preventDefault(); // prevent page scroll on touch, text-select on mouse
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      if (moved) {
        bubbleDragged = true;
        snap();
        // After snap animation completes, reposition and re-show the label
        if (_labelShown) {
          var lbl = document.getElementById('tcpBubbleLabel');
          setTimeout(function () {
            _positionLabel(lbl);
            if (lbl) lbl.classList.add('is-visible');
          }, 320);
        }
      }
    }

    bubbleBtn.addEventListener('mousedown',  onStart);
    bubbleBtn.addEventListener('touchstart', onStart, { passive: false });
    document.addEventListener('mousemove',   onMove);
    document.addEventListener('touchmove',   onMove,  { passive: false });
    document.addEventListener('mouseup',     onEnd);
    document.addEventListener('touchend',    onEnd);

    // Restore last saved position (persists across page navigations).
    // v:2 version key ignores entries saved by old code (which had bottom-left default)
    // so phones with a stale position don't get stuck at the old bottom position.
    try {
      var raw = localStorage.getItem('tpc_bubble_pos');
      if (raw) {
        var pos = JSON.parse(raw);
        if (pos.v === 2) {
          var w = bubbleBtn.offsetWidth  || 58;
          var h = bubbleBtn.offsetHeight || 58;
          setXY(
            clamp(pos.left, MARGIN, window.innerWidth  - w - MARGIN),
            clamp(pos.top,  MARGIN, window.innerHeight - h - MARGIN)
          );
        } else {
          localStorage.removeItem('tpc_bubble_pos'); // clear stale entry
        }
      }
    } catch (_) {}
  }());

  // ── Product page label — show bubble + callout on every product page ────────
  (function () {
    var pageProduct = window.TCP_PAGE_PRODUCT || null;
    if (!pageProduct) return;
    // Suppress on ad-traffic pages — the ad overlay handles engagement there
    if (new URLSearchParams(window.location.search).get('ref') === 'ad') return;

    var labelEl = document.getElementById('tcpBubbleLabel');
    if (!labelEl) return;

    // Alternate between two callout texts to avoid feeling repetitive
    var _texts = [
      'تبي تعرف اكثر عن المنتج؟\nاضغط هنا',
      'اختيار ممتاز ✨\nتحب تعرف معلومات اكثر؟\nاضغط هنا',
    ];
    var _text = _texts[Math.floor(Math.random() * _texts.length)];

    // Build label DOM: [×] dismiss row + text span
    var dismissRow = document.createElement('div');
    dismissRow.className = 'tcp-label-dismiss-row';
    var xBtn = document.createElement('button');
    xBtn.type = 'button';
    xBtn.className = 'tcp-label-x';
    xBtn.setAttribute('aria-label', 'Dismiss');
    xBtn.textContent = '×';
    dismissRow.appendChild(xBtn);

    var textSpan = document.createElement('span');
    textSpan.className = 'tcp-label-text';
    textSpan.textContent = _text;

    labelEl.appendChild(dismissRow);
    labelEl.appendChild(textSpan);

    function dismissLabel() {
      _labelShown = false;
      labelEl.classList.remove('is-visible');
      setTimeout(function () { labelEl.hidden = true; }, 280);
    }

    function showLabel() {
      if (panelOpen) return;      // chat panel is open — don't crowd it
      if (_labelDismissed) return; // user explicitly closed the callout
      _positionLabel(labelEl);
      labelEl.hidden = false;
      bubbleBtn.classList.add('is-visible');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          labelEl.classList.add('is-visible');
          _labelShown = true;
        });
      });
      setTimeout(function () {
        if (!_labelDismissed) dismissLabel();
      }, 12000); // auto-dismiss after 12 s
    }

    xBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // don't trigger the label's click-to-open
      _labelDismissed = true;
      dismissLabel();
    });

    labelEl.addEventListener('click', function () {
      dismissLabel();
      initWithProduct(pageProduct);
    });

    // Show after a brief settle delay so page layout is stable
    setTimeout(showLabel, 900);
  }());

  // ── Init: restore previous session if one exists ─────────────────────────────
  (function () {
    if (loadSession()) {
      restoreConversation();
      chatEverOpened = true;
      bubbleBtn.classList.add('is-visible');
    }
    // No session: bubble stays hidden until first open via any launcher
  }());

}());
